<template>
  <b-tab title="Imagens" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE IMAGENS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterImagens(filtro)" :fields="fields.imagem">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="Imagem">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="imagem-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição da imagem."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <imagem-modal ref="editor" />
      <display-modal ref="display" :size="'sm'" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useImagemStore } from "@/stores/ImagemStore";
import Imagem from "@/models/Imagem";
import TableFields from "@/tools/TableFields";
import ImagemModal from "@/components/modals/imagem/ImagemModal";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import Files from "@/http/files";

export default {
  name: "ImagemTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      imagem: new Imagem(0, "", "", new Date()),
      files: new Files(this.$http),
    };
  },

  components: {
    "imagem-modal": ImagemModal,
    "display-modal": DisplayModal,
  },

  methods: {
    adicionar() {
      this.imagem = new Imagem(0, "", "", new Date());
      this.$refs.editor.call(this.imagem);
    },

    editar(imagem) {
      this.$refs.editor.call(imagem);
    },

    display(imagem) {
      this.files.downloadImagem(imagem.id).then((response) => this.$refs.display.call(response));
    },
  },

  setup() {
    const store = useSgcqStore();
    const imagemStore = useImagemStore();
    const { getFilterImagens } = storeToRefs(imagemStore);

    return {
      store,
      imagemStore,
      getFilterImagens,
    };
  },
};
</script>

<style lang="scss" scoped>
#imagem-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
